import React from 'react'
import { Link } from 'react-router-dom'

const SectionTwo = () => {
    return (      
            <div className='container'>
                <h6 className='mb-6 text-sm text-white header-font'>SUPPORT</h6 >
                <div className="text-sm text-gray-500">
                    <p className='mt-3 '><Link to='/Contact-us'>Contact Us</Link></p>
                    <p className='mt-3 '>Offers</p>
                </div>
            </div>     
    )
}

export default SectionTwo
